import { render, staticRenderFns } from "./interior-design.vue?vue&type=template&id=0fe73b6b&scoped=true"
import script from "./interior-design.vue?vue&type=script&lang=js"
export * from "./interior-design.vue?vue&type=script&lang=js"
import style0 from "./interior-design.vue?vue&type=style&index=0&id=0fe73b6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe73b6b",
  null
  
)

export default component.exports